import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: 'auto',
    maxWidth: 172,
    height: 36,
    objectFit: 'contain',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.logo}
      src="/aranox-brand/aranox-preto.png"
      alt="ARANOX"
    />
  );
};
